// extracted by mini-css-extract-plugin
module.exports = {"input":"Search_input__3_v_j","wrap":"Search_wrap__nF5y7"};